import React, { useState } from 'react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import './index.css'
import App from './App.jsx'
import LandingPage from './components/LandingPage.jsx'
import CoachLandingPage from './components/CoachLandingPage.jsx'
import SomaLandingPage from './components/SomaLandingPage.jsx'
import ManifestoPage from './components/ManifestoPage.jsx'
import AcceptInvite from './components/AcceptInvite.jsx'
import NativeSplash from './components/NativeSplash.jsx'
import { Capacitor } from '@capacitor/core'

// PWA Service Worker Registration
import { registerSW } from 'virtual:pwa-register'

const isNative = Capacitor.isNativePlatform();

if (isNative && 'serviceWorker' in navigator) {
  // En aplicaciones nativas (Capacitor), los Service Workers de PWA causan problemas severos de caché
  // Desactivamos cualquier Service Worker existente para que la app lea los archivos locales reales
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
    }
  });
}

const updateSW = registerSW({
  onNeedRefresh() {
    if (!isNative) updateSW(true);
  },
  onOfflineReady() {}
})

import ErrorBoundary from './components/ErrorBoundary';
import PageViewTracker from './components/PageViewTracker';

const RootApp = () => {
  const [showSplash, setShowSplash] = useState(isNative);

  return (
    <BrowserRouter>
      <PageViewTracker />
      {showSplash && <NativeSplash onFinish={() => setShowSplash(false)} />}
      <Routes>
        <Route path="/" element={isNative ? <Navigate to="/app" replace /> : <LandingPage />} />
        <Route path="/mentor" element={isNative ? <Navigate to="/app" replace /> : <CoachLandingPage />} />
        <Route path="/soma" element={isNative ? <Navigate to="/app" replace /> : <SomaLandingPage />} />
        <Route path="/manifiesto" element={isNative ? <Navigate to="/app" replace /> : <ManifestoPage />} />
        <Route path="/app" element={<App />} />
        <Route path="/invite" element={<AcceptInvite />} />
        <Route path="*" element={isNative ? <Navigate to="/app" replace /> : <LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
};

import { HelmetProvider } from 'react-helmet-async';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <RootApp />
      </HelmetProvider>
    </ErrorBoundary>
  </StrictMode>,
)
